import { createSelector } from '@ngrx/store'

export const getCompoundSettingsState = createSelector(
  (state: any) => state.compoundSettings,
  (state: any) => state,
)
